export default __webpack_public_path__ + "static/media/banner_right_image.b75129bf.png";